import React from 'react';

function ContactUs() {
  return (
    <div className="min-h-screen bg-[#0B0F17] text-gray-100 py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold mb-8 bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
          Contact Us
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
          {/* FAQ Sections */}
          <div className="bg-gray-900/30 backdrop-blur-sm rounded-2xl p-6 border border-gray-800/50">
            <h2 className="text-xl font-semibold text-white mb-6">Getting Started</h2>
            <div className="space-y-4 text-gray-400">
              <div>
                <h3 className="text-white mb-2">How do I create an account?</h3>
                <p className="text-sm">You can sign up using your Google account or email address.</p>
              </div>
              <div>
                <h3 className="text-white mb-2">What plans are available?</h3>
                <p className="text-sm">We offer a Premium plan and then a Top-up on it. For details refer to the Pricing page.</p>
              </div>
            </div>
          </div>

          <div className="bg-gray-900/30 backdrop-blur-sm rounded-2xl p-6 border border-gray-800/50">
            <h2 className="text-xl font-semibold text-white mb-6">Using the Platform</h2>
            <div className="space-y-4 text-gray-400">
              <div>
                <h3 className="text-white mb-2">How do mock interviews work?</h3>
                <p className="text-sm">Our AI interviewer conducts realistic interview simulations and provides feedback.</p>
              </div>
              <div>
                <h3 className="text-white mb-2">Can I review my performance?</h3>
                <p className="text-sm">Yes, you can access detailed feedback and score after each session.</p>
              </div>
            </div>
          </div>

          <div className="bg-gray-900/30 backdrop-blur-sm rounded-2xl p-6 border border-gray-800/50">
            <h2 className="text-xl font-semibold text-white mb-6">Account & Billing</h2>
            <div className="space-y-4 text-gray-400">
              <div>
                <h3 className="text-white mb-2">How do I upgrade my plan?</h3>
                <p className="text-sm">Visit the pricing page and select your desired plan to upgrade.</p>
              </div>
              <div>
                <h3 className="text-white mb-2">What payment methods are accepted?</h3>
                <p className="text-sm">We accept all major credit cards and selected digital payment methods.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Support */}
        <div className="mt-12 bg-gray-900/30 backdrop-blur-sm rounded-2xl p-8 border border-gray-800/50 max-w-2xl mx-auto">
          <h2 className="text-2xl font-semibold text-white mb-6">Need More Help?</h2>
          <p className="text-gray-400 mb-6">
            Our support team is available 24/7 to assist you with any questions or concerns.
          </p>
          <a 
            href="mailto:iimcatinterview@gmail.com" 
            className="inline-block px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg hover:opacity-90 transition-opacity"
          >
            Contact Support
          </a>
        </div>
      </div>
    </div>
  );
}

export default ContactUs; 